const TRITON_ERROR_BASE = 0x0b00;
export const TritonErrorCodes = Object.freeze({
  /**
   * Indicates that sideband metadata connection failed after retries.
   */
  SERVER_SENT_EVENT_SOURCE_FAILURE: TRITON_ERROR_BASE + 0x01,
  /**
   * Indicates Ad VAST document failed.
   */
  AD_VAST_DOCUMENT_FAILURE: TRITON_ERROR_BASE + 0x02,

  /**
   * Indicates companion ad banner failure.
   */
  COMPANION_AD_BANNER_FAILURE: TRITON_ERROR_BASE + 0x03,
});
